import { z } from "zod";
import { Timestamps } from "../../common/index.ts";
import {
  DocumentTypeId,
  FsmTranslationsSchema,
  CustomerId,
} from "../fsm.schema.ts";

/**
 * @description A DocumentType defines the structure of a specific type of document within the FSM, including its possible states and transitions.
 */
export const DocumentTypeDto = z
  .object({
    id: DocumentTypeId,
    customerId: CustomerId,
    name: z.string().min(1),
    description: z.string().nullable(),
    key: z.string().min(1).nullable(),
    slug: z.string(),
    translations: FsmTranslationsSchema.nullable(),
    displayOrder: z.number().int().default(0),
  })
  .merge(Timestamps);

export type DocumentTypeDto = z.infer<typeof DocumentTypeDto>;

export const CreateDocumentTypeInput = z.object({
  name: z.string().min(1),
  description: z.string().nullable().optional(),
  key: z.string().min(1).optional(),
  customerId: CustomerId,
  translations: FsmTranslationsSchema.optional(),
});
export type CreateDocumentTypeInput = z.infer<typeof CreateDocumentTypeInput>;

export const UpdateDocumentTypeInput = z.object({
  name: z.string().min(1).optional(),
  description: z.string().nullable().optional(),
  key: z.string().min(1).optional(),
  customerId: CustomerId.optional(),
  translations: FsmTranslationsSchema.nullable().optional(),
});
export type UpdateDocumentTypeInput = z.infer<typeof UpdateDocumentTypeInput>;
